import { Injectable } from "@angular/core";
import { DiarioEmocion } from "../models";
import { databases, ID } from "../config/appwrite";
import { environment } from "src/environments/environment";
import { Query } from "appwrite";

@Injectable({
  providedIn: "root",
})
export class EmocionesDiarioService {
  private collectionId = "diario_emociones";
  private DATABASE_NAME = environment.databaseName;

  constructor() {}

  getByRangoFechas(
    idPaciente: string,
    fechaInicio: string,
    fechaFin: string
  ): Promise<DiarioEmocion[]> {
    return databases
      .listDocuments<DiarioEmocion>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("idPaciente", idPaciente),
        Query.greaterThanEqual("fecha", fechaInicio),
        Query.lessThanEqual("fecha", fechaFin),
        Query.orderAsc("fecha"),
        Query.limit(7),
      ])
      .then((response) => response.documents);
  }

  getByMes(idPaciente: string, anio: number, mes: number): Promise<DiarioEmocion[]> {
    const fechaInicio = `${anio}-${String(mes).padStart(2, "0")}-01`;
    const ultimoDia = new Date(anio, mes, 0).getDate();
    const fechaFin = `${anio}-${String(mes).padStart(2, "0")}-${ultimoDia}`;
    return databases
      .listDocuments<DiarioEmocion>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("idPaciente", idPaciente),
        Query.greaterThanEqual("fecha", fechaInicio),
        Query.lessThanEqual("fecha", fechaFin),
        Query.orderAsc("fecha"),
        Query.limit(31),
      ])
      .then((response) => response.documents);
  }

  crear(data: any): Promise<DiarioEmocion> {
    return databases.createDocument<DiarioEmocion>(
      this.DATABASE_NAME,
      this.collectionId,
      ID.unique(),
      data
    );
  }
}
